module.exports = __webpack_public_path__ + "img/3.47d0851c.jpg";